import React from 'react';
import s from './FormControls.module.css';

// A radio and a checkbox with a label, and optionally a line of help under it.
//
// The help line is why these exist rather than bare inputs: MMS explains most
// of its options in a smaller line beneath.

export function Radio({ name, checked, onChange, label, help, disabled = false }) {
  return (
    <label className={disabled ? s.rowDisabled : s.row}>
      <input
        type="radio" name={name} checked={checked} onChange={onChange}
        disabled={disabled} className={s.radio}
      />
      <span>
        <span className={s.label}>{label}</span>
        {help ? <span className={s.help}>{help}</span> : null}
      </span>
    </label>
  );
}

export function Check({ checked, onChange, label, help, disabled = false }) {
  return (
    <label className={disabled ? s.rowDisabled : s.row}>
      <input
        type="checkbox" checked={checked} onChange={onChange}
        disabled={disabled} className={s.radio}
      />
      <span>
        <span className={s.label}>{label}</span>
        {help ? <span className={s.help}>{help}</span> : null}
      </span>
    </label>
  );
}

// A small bold caption above a group of radios — not a heading, because these
// sit inside a section that already has one.
export function GroupLabel({ children }) {
  return <div className={s.groupLabel}>{children}</div>;
}
